<mat-toolbar>

    <button matButton type="button" class="logo-button" (click)="menuClick()"
        attr.aria-label="{{ 'menu.menuToggle' | translate }}"
        matTooltip="{{ 'menu.menuToggle' | translate }}">
        <img class="logo" src="/images/logo2.png" alt="" />
    </button>

    <div class="title" routerLink="/">{{'app.title' |  translate}} | {{title()}}</div>

    <div class="remaining-space"></div>

    <app-help-button (click)="clickEvent.emit('help')" />

    <app-full-screen-button />
    
    <app-notifications-button (click)="clickEvent.emit('notifications')" />
    
    <app-preferences-button (click)="clickEvent.emit('preferences')" />

    <app-avatar-button />

</mat-toolbar>